import { useCurrentUser } from '@artic/api-client';
import { createFileRoute } from '@tanstack/react-router';

import { AuditGridView } from '../../features/audit/audit-grid-view';

// Always on (no per-partner feature flag). Access is restricted to Artic team
// members via the same email-domain check the /admin routes use, so a direct URL
// hit can't bypass the "Artic Admin"-only sidebar placement.
export const Route = createFileRoute('/audit/')({
  staticData: {
    section: 'Admin',
    breadcrumb: 'Audit Viewer',
    layout: 'full-height',
  },
  component: AuditViewerPage,
});

function AuditViewerPage() {
  const { user } = useCurrentUser();
  const isAdmin = user.email.endsWith('@artic.works') || user.email.endsWith('@trunk.works');

  if (!isAdmin) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <h2 className="text-lg font-semibold">Access Denied</h2>
        <p className="text-muted-foreground text-sm">
          The Audit Viewer is only available to Artic team members.
        </p>
      </div>
    );
  }

  return <AuditGridView />;
}
